const radii = {
    none: '0',
    full: '50%',
}

export default radii
